import dynamic from 'next/dynamic';

export const Store = dynamic(() => import('./store'));
export const Product = dynamic(() => import('./product'));
export const Orders = dynamic(() => import('./orders'));
export const LandingPage = dynamic(() => import('./landingPage'));
